import { TIMEOUT_SEC } from './config.js';
const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};
export const AJAX = async function (url, uploadData = null) {
  try {
    const ferchPro = uploadData
      ? fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(uploadData),
        })
      : fetch(url);
    const res = await Promise.race([ferchPro, timeout(TIMEOUT_SEC)]);
    const data = await res.json();
    if (!res.ok || data.status === 'fail')
      throw `${data.message} (${data.status})`;
    return data;
  } catch (err) {
    throw err;
  }
};
/*
export const getJson = async function (url) {
  try {
    const res = await Promise.race([ferchPro, timeout(TIMEOUT_SEC)]);
    const data = await res.json();
    if (!res.ok || data.status === 'fail')
      throw `${data.message} (${data.status})`;
    return data;
  } catch (err) {
    throw err;
  }
};
export const sendJson = async function (url, uploadData) {
  try {
    const res = await Promise.race([
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(uploadData),
      }),
      timeout(TIMEOUT_SEC),
    ]);
    const data = await res.json();
    if (!res.ok || data.status === 'fail')
      throw `${data.message} (${data.status})`;
    return data;
  } catch (err) {
    throw err;
  }
};
*/
